'use strict';

frontendApp.controller('SettingsCtrl', ['$rootScope', '$scope', '$location', 'HttpService', 'AccountService', 'ConfigService', 'NotificationService', 'NavigationService', function($rootScope, $scope, $location, HttpService, AccountService, ConfigService, NotificationService, NavigationService) {

    NavigationService.clearActiveTab();
    $rootScope.$broadcast('clearCurrentSelected');
    $rootScope.$broadcast("navigation.batch.deselect");
    
    $scope.account = angular.copy(AccountService.Get());
    $scope.saving = false;

    $scope.saveAccount = function() {

        $scope.saving = true;
        AccountService.Update($scope.account, function() {
            $scope.saving = false;
        });
        
    };
    
}]);
